import { Empty } from 'antd';
import { EmptyIcon } from 'assets/icon/bigicon';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import _ from 'underscore';
import { deletePromotion, fetchPromotion } from 'state/actions/promotion';
import EventCards from 'design-components/EventCards';
import ModalPreview from 'components/ModalPreview';
import { CircularProgress } from '@material-ui/core';
import ModalDelete from 'components/ModalDelete';
import { FilterIcon } from 'assets/icon';
import CategoryDropdown from 'components/CategoryDropdown';
import { setTabDeal } from 'state/actions/breadcrumb';
import { filterAccess } from 'components/Report/utils';
import './Deals.css';
import ModalCodeBlock from 'components/ModalCodeBlock';

function Deals({ history }) {
  const [search, setSearch] = useState();
  const [modalPreview, setModalPreview] = useState({ isOpen: false, data: {} });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, promotion: null });
  const [typeOpen, setTypeOpen] = useState(false);
  const [selectedType, setSelectedType] = useState('all');
  const [tempSelectedType, setTempSelectedType] = useState(selectedType);
  const { siteId, siteName } = useParams();
  const [modalCode, setModalCode] = useState({ isOpen: false, data: {} });

  const { promotionList, loading, selectedTab, userData } = useSelector(
    (state) => ({
      promotionList: state.promotions.list,
      loading: state.promotions.loading,
      userData: state.auth.userData,
      selectedTab: state.breadcrumb.deal,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPromotion({ siteId, type: selectedTab }));
  }, [siteId, selectedTab, dispatch]);

  const sourceTypes = [
    { _id: 'scape-api', name: 'SCAPE API' },
    { _id: 'manual', name: 'Adsign' },
  ];

  const getType = (type) => {
    if (type === 'all') {
      return 'Show All';
    }
    const findType = sourceTypes.find((t) => t._id === type);
    return findType?.name;
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDeletePromotion = () => {
    dispatch(
      deletePromotion({ id: deleteModal.promotion, siteId }, () => {
        setDeleteModal({ isOpen: false, promotion: null });
      })
    );
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/deal/${id}`);
  };

  const onRemoveButtonClickHandler = (promotion) => {
    setDeleteModal((prevState) => ({
      promotion,
      isOpen: !prevState.isOpen,
    }));
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ promotion: null, isOpen: false });
  };

  const handleSetType = () => {
    setSelectedType(tempSelectedType);
    setTypeOpen(false);
  };

  const onTabClicked = (value) => {
    dispatch(setTabDeal(value));
  };

  // Transform API response to match component expectations
  const transformedPromotionList = promotionList.map((promotion) => {
    // If data comes from Suntec API (has EventID field), map the fields
    if (promotion.EventID || promotion.eventId) {
      return {
        ...promotion,
        name: promotion.Title || promotion.name,
        logo: promotion.ImagePath || promotion.EventImage || promotion.logo,
        source: promotion.modifiedBy === 'Suntec+' ? 'suntec-api' : promotion.source,
        modifiedAt: promotion.updatedAt || promotion.modifiedAt || promotion.StartDate || new Date().toISOString(),
      };
    }
    return promotion;
  });

  const dataBySource = transformedPromotionList.filter((promotion) => {
    if (selectedType === 'all') return true;
    if (selectedType === 'suntec-api') return promotion.source === 'suntec-api';
    if (selectedType === 'adobe-aem') return !promotion.source || promotion.source === 'adobe-aem';
    return true;
  });

  const filteredData = search
    ? dataBySource.filter((el) => {
        return el.name?.toLowerCase().includes(search.toLowerCase());
      })
    : dataBySource;

  return (
    <div className="media-library">
      <ModalPreview
        isVisible={modalPreview.isOpen}
        data={modalPreview.data}
        title="Preview Promotion"
        onCancel={() => {
          setModalPreview({ isOpen: false, data: {} });
        }}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={handleDeletePromotion}
        onCancel={onCloseModalHandler}
        title="Delete Promotion"
        subtitle={deleteModal.promotion?.name}
        loading={loading}
      />
    <ModalCodeBlock
            isVisible={modalCode.isOpen}
            data={modalCode.data}
            title="Raw Data Events"
            onCancel={() => {
              setModalCode({ isOpen: false, data: {} });
            }}
      />
      <div className="media-header media-header-topbar">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {filterAccess({
            userData,
            siteId,
            param: 'promotion',
            action: 'create',
          }) && (
            <Link
              to={`/${siteId}/information/${siteName}/deal/new`}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              New Deal
            </Link>
          )}
        </div>
      </div>

      <div className="media-header">
        <div className="media-header-left">
          <div
            className="playlist-wrapper"
            onClick={() => !loading && setTypeOpen(!typeOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>{getType(selectedType)}</span>
            </div>
            <i
              className={`feather-chevron-down ${
                typeOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={sourceTypes}
              modalOpen={typeOpen}
              handleSetPlaylist={handleSetType}
              setTempSelectedCategory={(id) => setTempSelectedType(id)}
              tempSelectedCategory={tempSelectedType}
              filter
              title="Source"
            />
          </div>
        </div>
      </div>
      <div className="media-content-wrapper">
        <div className="media-content">
          <div className="media-tab-wrapper">
            <div className="media-tab-left">
              <div
                onClick={() => onTabClicked('published')}
                className={`media-tab ${
                  selectedTab === 'published' ? 'active' : ''
                }`}
              >
                Active Deals
              </div>
              <div
                onClick={() => onTabClicked('unpublished')}
                className={`media-tab ${
                  selectedTab === 'unpublished' ? 'active' : ''
                }`}
              >
                Unpublished Deals
              </div>
            </div>
            Showing {filteredData.length} of {promotionList.length} results
          </div>
          <div className="media-list-content media-list-content-chunked">
            {loading && (
              <div className={'media-empty'}>
                <CircularProgress />
              </div>
            )}
            {!loading && filteredData.length > 0
              ? _.chunk(filteredData, 3).map((chunk, index) => {
                  return (
                    <div className="media-list-chunk" key={index}>
                      {chunk.map((promotion) => {
                        return (
                          <div
                            key={promotion._id}
                            data-id={promotion._id}
                            className="media-list"
                          >
                            <EventCards
                              data={promotion}
                              isShowMedia
                              editAction={() => handleEdit(promotion._id)}
                              deleteAction={() =>
                                onRemoveButtonClickHandler(promotion._id)
                              }
                              previewAction={() =>
                                setModalPreview({ isOpen: true, data: promotion })
                              }
                              dataAction={() =>
                              setModalCode({ isOpen: true, data: promotion })
                            }
                              isDeals={true}
                              isPreviewJSON
                            />
                          </div>
                        );
                      })}
                      {chunk.length < 2 && <div className="media-list-empty" />}
                      {chunk.length < 3 && <div className="media-list-empty" />}
                    </div>
                  );
                })
              : !loading && (
                  <div className="media-empty">
                    <Empty image={<EmptyIcon />} description="No Promotion" />
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deals;